import { render } from "./CreateNewOrder.vue?vue&type=template&id=3c77859e&scoped=true"
import script from "./CreateNewOrder.vue?vue&type=script&lang=js"
export * from "./CreateNewOrder.vue?vue&type=script&lang=js"

import "./CreateNewOrder.vue?vue&type=style&index=0&id=3c77859e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c77859e"]])

export default __exports__